{
  "consents": {
    "email": "E-post",
    "emptyEmailValidator": "Du må angi e-post",
    "error": "Noe gikk galt, vennligst prøv igjen senere.",
    "errorTryAgain": "Prøv igjen",
    "invalidEmailValidator": "Ugyldig e-post",
    "linkText": "Dersom din e-postadresse er registrert i våre systemer, har vi sendt en e-post til deg på:",
    "send": "Send",
    "submitNewCheck": "Ny e-post",
    "thanks": "Takk!"
  },
  "newsletter": {
    "firstname": "Fornavn",
    "lastname": "Etternavn",
    "emailAddress": "E-postadresse",
    "levels": "Studier",
    "campuses": "Studiesteder",
    "subjects": "Faginteresser",
    "submit": "Send",
    "error": "Noe gikk galt, vennligst prøv igjen senere.",
    "consentValidator": "Du må samtykke",
    "firstnameValidator": "Du må angi fornavn",
    "lastnameValidator": "Du må angi etternavn",
    "levelValidator": "Du må velge et studie",
    "mailValidator": "Du må angi e-post",
    "mailFormatValidator": "Feil format på e-post"
  }
}
